import { render, staticRenderFns } from "./SpecialTopicDetail.vue?vue&type=template&id=0b255931&scoped=true&"
import script from "./SpecialTopicDetail.vue?vue&type=script&lang=js&"
export * from "./SpecialTopicDetail.vue?vue&type=script&lang=js&"
import style0 from "./SpecialTopicDetail.vue?vue&type=style&index=0&id=0b255931&rel=stylesheet%2Fscss&lang=scss&scoped=true&"
import style1 from "./SpecialTopicDetail.vue?vue&type=style&index=1&id=0b255931&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b255931",
  null
  
)

export default component.exports